import { useEffect, useState } from 'react';
import { Flame, Loader2, Save } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';

export const StreakBulkSetter = ({ readerNumber, initial, onDone }) => {
  const [value, setValue] = useState(initial);
  const [saving, setSaving] = useState(false);

  useEffect(() => { setValue(initial); }, [initial]);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(
        `/admin/badges/progress/${encodeURIComponent(readerNumber)}/override-type/streak_days`,
        { current: Math.max(0, Number(value) || 0) },
      );
      toast.success(data.auto_granted?.length ? `${data.message} ومُنح ${data.auto_granted.length} وسام` : data.message);
      onDone();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'فشل الضبط');
    } finally { setSaving(false); }
  };

  return (
    <Card className="p-4 border-2 border-rose-200 bg-rose-50/30" data-testid="streak-bulk-setter">
      <div className="flex flex-col md:flex-row md:items-end gap-3">
        <div className="flex-1">
          <h4 className="font-bold text-accent flex items-center gap-2 text-sm">
            <Flame className="w-4 h-4 text-rose-500" /> ضبط كل أوسمة الاستمرار دفعة واحدة
          </h4>
          <p className="text-[11px] text-muted-foreground mt-1">
            اكتب رقم اليوم الحالي للقارئ (مثلاً 48)، وسيُطبَّق على الاستمرارية والديمومة والعزيمة والسنة القرائية، ثم يكمل العدّ تلقائياً مع كل يوم نشاط.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Input type="number" min="0" value={value} onChange={(e) => setValue(e.target.value)}
            className="h-10 w-28" data-testid="streak-bulk-input" />
          <Button onClick={save} disabled={saving || value === ''} className="h-10 bg-rose-600 hover:bg-rose-700 text-white gap-1" data-testid="streak-bulk-save-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} تطبيق
          </Button>
        </div>
      </div>
    </Card>
  );
};
